import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_ENDPOINT } from '../../../config/config';
import axiosInstance from '../../../service/axiosInstance';

// export const getPlayersForRankings = createAsyncThunk(
// 	'ranking-players/getPlayersForRankings',
// 	async ({ setLimit, setPosition, setSearch }, { dispatch, getState, rejectWithValue }) => {
// 		try {
// 			const {
// 				ranking: { limit, positionRanked, positionChoose },
// 			} = getState();
// 			const playerLimit = setLimit ? setLimit : limit;
// 			const playersPosition = setPosition ? setPosition : positionChoose;
// 			const playersSearch = setSearch ? setSearch : '';
// 			const res = await axiosInstance.get(
// 				`${API_ENDPOINT}players/?limit=${playerLimit}&offset=${0}&search=${playersSearch}&position=${playersPosition}&school`
// 			);
// 			const resData = { ...res.data, limit: playerLimit, position: playersPosition, search: playersSearch };
// 			return resData;
// 		} catch (error) {
// 			if (error.response && error.response.data.message) {
// 				return rejectWithValue(error.response.data.message);
// 			} else {
// 				return rejectWithValue(error.message);
// 			}
// 		}
// 	}
// );

//15.09
export const getPlayersForRankings = createAsyncThunk(
	'ranking-players/getPlayersForRankings',
	async ({ setLimit, setPosition, setSearch }, { dispatch, getState, rejectWithValue }) => {
		try {
			const {
				ranking: { limit, positionRanked, positionChoose },
			} = getState();

			const playerLimit = setLimit ? setLimit : limit;
			// const rawPosition = setPosition ?? positionChoose;
			const rawPosition =setPosition ? setPosition : positionChoose;
			const playersSearch = setSearch ?? '';
			let positionQuery = '';
			if (rawPosition === 'iOL') {
				positionQuery = '&position=iOL&position=iOL_C';
			} else if (rawPosition && rawPosition !== 'All') {
				positionQuery = `&position=${rawPosition}`;
			}
			const res = await axiosInstance.get(
				`${API_ENDPOINT}players/?limit=${playerLimit}&offset=0&search=${playersSearch}${positionQuery}&school`
			);
			const resData = {
				...res.data,
				limit: playerLimit,
				position: rawPosition,
				search: playersSearch,
			};
			return resData;
		} catch (error) {
			if (error.response?.data?.message) {
				return rejectWithValue(error.response.data.message);
			}
			return rejectWithValue(error.message);
		}
	}
);




export const getRanking = createAsyncThunk('ranking-data/getRanking', async (_, { rejectWithValue }) => {
	try {
		const res = await axiosInstance.get(`${API_ENDPOINT}ranking`);
		const resData = { ...res.data };
		return resData;
	} catch (error) {
		if (error.response && error.response.data.message) {
			return rejectWithValue(error.response.data.message);
		} else {
			return rejectWithValue(error.message);
		}
	}
});

export const getRankingPosition = createAsyncThunk(
	'ranking-position/getRankingPosition',
	async ({ id }, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get(`${API_ENDPOINT}ranking/${id}`);
			const resData = { ...res.data };
			return resData;
		} catch (error) {
			if (error.response && error.response.data.message) {
				return rejectWithValue(error.response.data.message);
			} else {
				return rejectWithValue(error.message);
			}
		}
	}
);

// export const saveRankingPosition = createAsyncThunk(
// 	'ranking-position-save/saveRankingPosition',
// 	async (data, { rejectWithValue }) => {
// 		//debugger me;
// 		try {
// 			const res = await axiosInstance.post(`${API_ENDPOINT}ranking/position/`, {
// 				...data,
// 			});
// 			const resData = { ...res.data };
// 			return resData;
// 		} catch (error) {
// 			if (error.response && error.response.data.message) {
// 				return rejectWithValue(error.response.data.message);
// 			} else {
// 				return rejectWithValue(error.message);
// 			}
// 		}
// 	}
// );



const normalizePosition = (position) => {
	switch (position) {
		case 'iOL_C':
			return 'iOL';
		default:
			return position;
	}
};
//15.09
export const saveRankingPosition = createAsyncThunk(
	'ranking-position-save/saveRankingPosition',
	async (data, { rejectWithValue }) => {
		try {
			// ✅ Normalize the group name before sending to backend
			const normalizedData = {
				...data,
				name: normalizePosition(data.name),
			};

			const res = await axiosInstance.post(`${API_ENDPOINT}ranking/position/`, normalizedData);
			return res.data;

		} catch (error) {
			if (error.response?.data?.message) {
				return rejectWithValue(error.response.data.message);
			} else {
				return rejectWithValue(error.message);
			}
		}
	}
);


// export const updateRankingPosition = createAsyncThunk(
// 	'ranking-position-update/updateRankingPosition',
// 	async ({ playerId, checkDBSave }, { getState, rejectWithValue }) => {
// 		try {
// 			const {
// 				ranking: { rankId, rankedPlayers, positionRanked },
// 			} = getState();
// 			let positionId = null;
// 			let players = [];
// 			if (playerId === undefined && checkDBSave) {
// 				// 2 save check
// 				players = checkDBSave.players;
// 				positionId = checkDBSave.id;
// 			} else if (playerId === undefined && checkDBSave === undefined) {
// 				// remove all players
// 				const existingPositionGroup = rankedPlayers.find(group => group.name === positionRanked);
// 				positionId = existingPositionGroup.id;
// 				players = [];
// 			} else {
// 				// remove one player
// 				const updatedGroup = rankedPlayers.find(group => group.players.some(player => player.id === playerId));
// 				const updatedPlayers = updatedGroup.players.filter(player => player.id !== playerId);
// 				positionId = updatedGroup.id;
// 				players = updatedPlayers;
// 			}
// 			const res = await axiosInstance.patch(`${API_ENDPOINT}ranking/${rankId}/position/${positionId}/`, {
// 				players,
// 			});
// 			const resData = { ...res.data };
// 			return resData;
// 		} catch (error) {
// 			if (error.response && error.response.data.message) {
// 				return rejectWithValue(error.response.data.message);
// 			} else {
// 				return rejectWithValue(error.message);
// 			}
// 		}
// 	}
// );

//15.09

export const updateRankingPosition = createAsyncThunk(
	'ranking-position-update/updateRankingPosition',
	async ({ playerId, checkDBSave }, { getState, rejectWithValue }) => {
		try {
			const {
				ranking: { rankId, rankedPlayers, positionRanked },
			} = getState();

			let positionId = null;
			let players = [];

			if (playerId === undefined && checkDBSave) {
				// ✅ Normalize position name
				// const normalizedName = normalizePosition(checkDBSave.name);
				const normalizedName = checkDBSave.name;

				// Find the normalized group to get the correct position ID
				const normalizedGroup = rankedPlayers.find(
					group => group.name === normalizedName
				);

				if (!normalizedGroup) {
					throw new Error(`Could not find position group for ${normalizedName}`);
				}

				players = checkDBSave.players;
				positionId = normalizedGroup.id;

			} else if (playerId === undefined && checkDBSave === undefined) {
				// ✅ Remove all players from the normalized group
				const normalizedName = normalizePosition(positionRanked);
				const existingPositionGroup = rankedPlayers.find(
					group => group.name === normalizedName
				);

				if (!existingPositionGroup) {
					throw new Error(`Could not find position group for ${normalizedName}`);
				}

				positionId = existingPositionGroup.id;
				players = [];

			} else {
				// ✅ Remove a single player
				const updatedGroup = rankedPlayers.find(
					group => group.players.some(player => player.id === playerId)
				);

				if (!updatedGroup) {
					throw new Error(`Could not find position group containing player ID ${playerId}`);
				}

				const updatedPlayers = updatedGroup.players.filter(player => player.id !== playerId);
				positionId = updatedGroup.id;
				players = updatedPlayers;
			}

			const res = await axiosInstance.patch(
				`${API_ENDPOINT}ranking/${rankId}/position/${positionId}/`,
				{ players }
			);

			const resData = { ...res.data };
			return resData;

		} catch (error) {
			if (error.response && error.response.data.message) {
				return rejectWithValue(error.response.data.message);
			} else {
				return rejectWithValue(error.message);
			}
		}
	}
);


// export const updateRankingPosition = createAsyncThunk(
// 	'ranking-position-update/updateRankingPosition',
// 	async ({ playerId, checkDBSave }, { getState, rejectWithValue }) => {
// 		try {
// 			const {
// 				ranking: { rankId, rankedPlayers, positionRanked },
// 			} = getState();
//
// 			let positionId = null;
// 			let players = [];
//
//
// // 			const res = await axiosInstance.patch(`${API_ENDPOINT}ranking/${rankId}/position/${positionId}/`, {
// // 				players,
// // 			});
// // 			const resData = { ...res.data };
// // 			return resData;
// // 		} catch (error) {
// // 			if (error.response && error.response.data.message) {
// // 				return rejectWithValue(error.response.data.message);
// // 			} else {
// // 				return rejectWithValue(error.message);
// // 			}
// // 		}
// // 	}
// // );
//
//
//
//
//
//
//
//
//
//
//
// 			// 			if (playerId === undefined && checkDBSave) {
// // 				// 2 save check
// // 				players = checkDBSave.players;
// // 				positionId = checkDBSave.id;
// // 			} else if (playerId === undefined && checkDBSave === undefined) {
// // 				// remove all players
// // 				const existingPositionGroup = rankedPlayers.find(group => group.name === positionRanked);
// // 				positionId = existingPositionGroup.id;
// // 				players = [];
// // 			} else {
// // 				// remove one player
// // 				const updatedGroup = rankedPlayers.find(group => group.players.some(player => player.id === playerId));
// // 				const updatedPlayers = updatedGroup.players.filter(player => player.id !== playerId);
// // 				positionId = updatedGroup.id;
// // 				players = updatedPlayers;
// // 			}
//
// 			// ✅ SAVE ENTIRE GROUP
// 			if (playerId === undefined && checkDBSave) {
// 				const normalizedName =checkDBSave.name;
// 				checkDBSave.name = normalizedName;
//
// 				// 🔍 Find matching group in rankedPlayers (also normalized)
// 				const existingGroup = rankedPlayers.find(
// 					group => group.name === normalizedName
// 				);
//
// 				if (!existingGroup) {
// 					throw new Error(`Could not find position group for ${normalizedName}`);
// 				}
//
// 				positionId = existingGroup.id;
//
// 				// 🧹 Optional: Deduplicate player list
// 				const uniquePlayers = checkDBSave.players.filter(
// 					(p, i, arr) => arr.findIndex(x => x.id === p.id) === i
// 				);
//
// 				players = uniquePlayers;
// 			}
//
// 			// ✅ CLEAR ENTIRE GROUP
// 			else if (playerId === undefined && checkDBSave === undefined) {
// 				const normalizedName = normalizePosition(positionRanked);
//
// 				const existingGroup = rankedPlayers.find(
// 					group => group.name === normalizedName
// 				);
//
// 				if (!existingGroup) {
// 					throw new Error(`Could not find position group for ${normalizedName}`);
// 				}
//
// 				positionId = existingGroup.id;
// 				players = [];
// 			}
//
// 			// ✅ REMOVE ONE PLAYER
// 			else {
// 				const updatedGroup = rankedPlayers.find(
// 					group => group.players.some(player => player.id === playerId)
// 				);
//
// 				if (!updatedGroup) {
// 					throw new Error(`Could not find group containing player ID ${playerId}`);
// 				}
//
// 				positionId = updatedGroup.id;
// 				players = updatedGroup.players.filter(player => player.id !== playerId);
// 			}
//
// 			console.log(players, "players")
//
// 			// ✅ Send update to backend
// 			const res = await axiosInstance.patch(
// 				`${API_ENDPOINT}ranking/${rankId}/position/${positionId}/`,
// 				{ players }
// 			);
//
// 			return res.data;
// 		} catch (error) {
// 			if (error.response?.data?.message) {
// 				return rejectWithValue(error.response.data.message);
// 			} else {
// 				return rejectWithValue(error.message);
// 			}
// 		}
// 	}
// );

export const updateRankingMode = createAsyncThunk(
	'ranking-mode-update/updateRankingMode',
	async (_, { getState, rejectWithValue }) => {
	try {
		const {
			ranking: { rankId, mode},
		} = getState();
		const newMode=!mode;
		const res = await axiosInstance.patch(`${API_ENDPOINT}ranking/${rankId}/`, {mode:newMode});
		console.log(res.data, "needed")
		return newMode;
	} catch (error) {
		if (error.response && error.response.data.message) {
			return rejectWithValue(error.response.data.message);
		} else {
			return rejectWithValue(error.message);
		}
	}
});